import { render, staticRenderFns } from "./SearchTasks.vue?vue&type=template&id=aebb0ca8"
import script from "./SearchTasks.vue?vue&type=script&lang=js"
export * from "./SearchTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports